module.exports = __webpack_public_path__ + "static/media/gitlab.cb09617a.png";